import React, { useState } from 'react';


export default function NotFound() {
    return (
        <div style={{ padding: 32 }}>
            <h1>404</h1>
            <p>This page does not exist.</p>
            <a href="/">Go home</a>
        </div>
    );
}